<div class="addCard_modal">
  <p-button
    class="close_modal"
    (click)="closeDialog()"
    role="button"
    tabIndex="0"
    icon="pi pi-times"
  ></p-button> 
  
  <div class="modal_title">
    <h2>Data Errors Detected</h2>
  </div>

  <div class="error_found hd_6">  
    <h3 class="fw_500">Errors Found: {{ errorCount }}</h3>
    
    <!-- Scrollable error list container -->
    <div class="error_list_container">
      <ul class="error_list">
        <li *ngFor="let error of errorList; let i = index">
          {{ error }}
        </li>
      </ul>
    </div>
  </div>

  <div class="btn_flex mt_20">
    <p-button
      label="Upload Again"
      (click)="uploadAgain()"
      role="button"
      tabIndex="1"
    ></p-button>
    
    <p-button
      label="Cancel"
      severity="contrast"
      variant="outlined"
      (click)="closeDialog()"
      tabIndex="2"
    />
  </div>
</div>
